import { z } from 'zod';
import { optionalDate } from './Scheduling';

export const associatedCampaignSchema = z.object({
  id: z.number(),
  name: z.string(),
  type: z.enum(['Lead', 'Opportunity']),
  createdAt: optionalDate,
  updatedAt: optionalDate,
});

export type AssociatedCampaign = z.infer<typeof associatedCampaignSchema>;
